// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__1n0yN","desabilitar":"OptionSelect_desabilitar__1kD4L","focado":"OptionSelect_focado__1EEh-","novo":"OptionSelect_novo__3x0Lc"};